import React, {useEffect, useState} from "react";
import {Table} from 'semantic-ui-react'
import {useNavigate, useParams} from "react-router";
import {CreditNoteLineItems} from "./CreditNoteLineItems";

export default function CreditNoteDetail(props) {
    const [data, setData] = useState({
        creditNote: {
            creditnote_id: 0,
            customer_name: "",
            creditnote_number: "",
            date: "",
            total: 0,
            balance: 0,
            credit_note_line_items: []

        }, loading: true
    });

    const navigate = useNavigate()
    const {creditNoteId} = useParams()

    useEffect(() => {
        document.title = 'Credit note detail'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        const url = API_URL + '/api/private/tanker/v1/credit-notes/' + creditNoteId;

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({creditNote: data, loading: false});
            });
    }

    const {creditNote} = data
    return <div>
        <h2>Detail {creditNoteId}</h2>
        <Table definition>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell></Table.HeaderCell>
                    <Table.HeaderCell>Value</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <tr>
                    <td>ID</td>
                    <td>{creditNote.id}</td>
                </tr>
                <tr>
                    <td>Zoho creditnote_id</td>
                    <td>{creditNote.creditnote_id}</td>
                </tr>
                <tr>
                    <td>Kunde</td>
                    <td>{creditNote.customer_name}</td>
                </tr>
                <tr>
                    <td>Gutschriftnummer</td>
                    <td>{creditNote.creditnote_number}</td>
                </tr>
                <tr>
                    <td>Datum</td>
                    <td>{creditNote.date}</td>
                </tr>

                <tr>
                    <td>Total inkl. MwSt</td>
                    <td>{creditNote.total} €</td>
                </tr>
                <tr>
                    <td>Balance</td>
                    <td>{creditNote.balance} €</td>
                </tr>
            </Table.Body>
        </Table>
        <h3>Line Items</h3>
        <CreditNoteLineItems creditNoteLineItems={creditNote.credit_note_line_items}/>
    </div>
}


